const translations = {
    resources: {
        invoices: {
            name: 'Facture |||| Factures',
            fields: {
                invoice_type: 'Type de facture',
                invoiced_at: 'Facturé le',
                due_date: 'Date d\'échéance',
                total_taxed: 'Total taxé',
                total_untaxed: 'Total non taxé',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                status: 'Statut',
                number: 'Numéro',
                billing_company_id: 'Société de facturation',
                customer_id: 'Client'
            }
        },
        leaves: {
            name: 'Congé |||| Congés',
            fields: {
                start_date: 'Date de début',
                end_date: 'Date de fin',
                duration: 'Durée',
                status: 'Statut',
                comments: 'Commentaires',
                user_id: 'Utilisateur',
                half_day: 'Demi-jour'
            }
        },
        customers: {
            name: 'Client |||| Clients',
            fields: {
                name: 'Nom',
                short_name: 'Nom court'
            }
        },
        projects: {
            name: 'Projet |||| Projets',
            fields: {
                name: 'Nom',
                status: 'Statut',
                color: 'Couleur',
                customer_id: 'Client',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                category: 'Catégorie',
                updated_at: 'Mis à jour le'
            }
        },
        time_entries: {
            name: 'Timesheet |||| Timesheet',
            fields: {
                hours: 'Heures',
                invoiced: 'Facturé',
                project_id: 'Projet',
                created_at: 'Créé le',
                default_date: 'Date par défaut'
            }
        },
        time_entry_types: {
            name: 'Type timesheet |||| Types timesheet',
            fields: {
                name: 'Nom'
            }
        },
        weeklies: {
            fields: {
                workload: 'Charge de travail',
                occupancy_rate: 'Taux d\'occupation',
                priorities: 'Priorités',
                tasks: 'Tâches',
                created_at: 'Créé le'
            }
        },
        suggestions: {
            fields: {
                title: 'Titre',
                category: 'Catégorie',
                status: 'Statut',
                created_at: 'Créé le'
            }
        },
        articles: {
            fields: {
                title: 'Titre',
                category: 'Catégorie',
                published: 'Publié',
                published_at: 'Publié le',
                content: 'Contenu',
                author: 'Auteur'
            }
        },
        news: {
            fields: {
                title: 'Titre',
                category: 'Catégorie',
                published: 'Publié',
                published_at: 'Publié le',
                content: 'Contenu',
                author: 'Auteur'
            }
        },
        users: {
            name: 'Utilisateur |||| Utilisateurs',
            fields: {
                active: 'Actif',
                email: 'E-mail',
                firstname: 'Prénom',
                lastname: 'Nom',
                password: 'Mot de passe',
                trigram: 'Trigramme',
                color: 'Couleur',
                status: 'Statut'
            }
        },
        account: {
            fields: {
                firstname: 'Prénom',
                lastname: 'Nom',
                password: 'Mot de passe'
            }
        },
        companies: {
            name: 'Société de facturation |||| Sociétés de facturation',
            fields: {
                name: 'Nom',
                country: 'Pays',
                street: 'Rue',
                zipcode: 'Code postal',
                city: 'Ville',
                vat_number: 'Numéro TVA',
                bank_name: 'Nom banque',
                bank_bic: 'BIC banque',
                bank_iban: 'IBAN banque',
                website: 'Site web',
                phone: 'Téléphone',
                updated_at: 'Mis à jour le'
            }
        },
        costs: {
            name: 'Coût |||| Coûts',
            fields: {
                name: 'Nom',
                vendor: 'Fournisseur',
                amount: 'Montant',
                frequency: 'Fréquence',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                category: 'Catégorie',
                amount_min: 'Montant min',
                amount_max: 'Montant max',
                is_variable: 'Est variable'
            }
        },
        reviews: {
            name: 'Évaluation |||| Évaluations',
            fields: {
                kind: 'Type',
                user_id: 'Personne',
                status: 'Statut',
                period_label: 'Période',
                period_start: 'Du',
                period_end: 'Au',
                stage_current: 'Étage actuel',
                stage_target: 'Étage visé',
                values_note: 'Valeurs incarnées',
                strengths: 'Points forts',
                improvements: 'Points à améliorer',
                objectives: 'Objectifs'
            }
        },
        budgets: {
            fields: {
                customer_id: 'Client',
                project_id: 'Projet',
                budget_type: 'Type de budget',
                hours_included: 'Heures incluses',
                amount: 'Montant',
                start_date: 'Date de début',
                end_date: 'Date de fin',
                is_active: 'Est actif'
            }
        }
    },
    'User': 'Utilisateur',
    'Name': 'Nom',
    'Number of days': 'Nombre de jours',
    'Search': 'Recherche',
    'Account': 'Compte',
    'Account updated': 'Compte mis à jour',
    'Leave validation': 'Validation du congé',
    'Other leaves at the same period': 'Autres congés à la même période',
    'Pending': 'En attente',
    'Accepted': 'Accepté',
    'Refused': 'Refusé',
    'Leave': 'Congé',
    'Recup': 'Récup',
    'Sick leave': 'Congé maladie',
    'Unpaid leave': 'Congé sans solde',
    'Other': 'Autre',
    'Useful links': 'Liens utiles',
    'Leaves': 'Congés',
    'Must be from the same month': 'Doit être du même mois',
    'Pending leaves': 'Congés en attente',
    'Current month': 'Mois courant',
    'This month': 'Ce mois-ci',
    'Next month': 'Mois prochain',
    'Last month': 'Mois précédent',
    'This year': 'Cette année',
    'Last year': 'L\'année dernière',
    'Reset': 'Réinitialiser',
    'Leave taken': 'Congés pris',
    'Remaining leave': 'Congés restants',
    'Recuperation days': 'Jours de récupération',
    'Other leave days': 'Autres jours de congés',
    'leaves.unpaid': 'Sans solde',
    'leaves.sick': 'Maladie',
    'Unpaid leave days': 'Congés sans solde',
    'Customer': 'Client',
    'Users': 'Utilisateurs',
    'Active': 'Actif',
    'Maintenance': 'Maintenance',
    'Paused': 'En pause',
    'Done': 'Fini',
    'Late': 'En retard',
    'Cancelled': 'Annulé',
    'Summary': 'Résumé',
    'Projects': 'Projets',
    'Project': 'Projet',
    'My projects only': 'Mes projets uniquement',
    'Hours': 'Heures',
    'Help': 'Aide',
    'Minimum duration of 0.25h': 'Durée minimum de 0,25h',
    '0.25h = 15 minutes': '0,25h = 15 minutes',
    'Set invoiced': 'Facturé(s)',
    'Last time entry': 'Dernière entrée timesheet',
    'Capacity': 'Capacité',
    'Last 7 days timesheet': 'Timesheet des 7 derniers jours',
    'Next leaves': 'Prochains congés',
    'My projects': 'Mes projets',
    'Links': 'Liens',
    'Last time entries': 'Dernières entrées timesheet',
    'Available': 'Disponible',
    'Low': 'Bas',
    'Normal': 'Normal',
    'High': 'Haut',
    'Overloaded': 'Surchargé',
    'Blocked': 'Bloqué',
    'My documents': 'Mes documents',
    'Priorities': 'Priorités',
    'Tasks': 'Tâches',
    'Last weekly': 'Dernier weekly',
    'Last monthly': 'Dernier monthly',
    'Never': 'Jamais',
    'See more': 'Voir plus',
    'Last Redmine tickets': 'Derniers tickets Redmine',
    'Accept': 'Accepter',
    'Refuse': 'Refuser',
    'Achievements': 'Succès',
    'Disciple of Nurgle': 'Disciple de Nurgle',
    'Took one day\'s sick leave': 'A pris un jour de congé maladie',
    'Took part in many meetings': 'A participé à beaucoup de réunions',
    'Took part in many calls and discussions': 'A participé à beaucoup d\'appels et de discussions',
    'Involved in many projects': 'Impliqué dans de nombreux projets',
    'Has filled his timesheet many times': 'A rempli sa timesheet de nombreuses fois',
    'Has filled his timesheet many times with more than 8 hours a day': 'A rempli sa timesheet de nombreuses fois avec plus de 8h par jour',
    'More work?': 'Encore du travail?',
    'Pain reinforces devotion': 'La douleur renforce la dévotion',
    'Time is an illusion. Lunchtime doubly so.': 'Le temps est une illusion. En particulier l\'heure du déjeuner.',
    'Marathoner': 'Marathonien',
    'Underwent very long meetings': 'A subi de très longues réunions',
    'Hang by a thread': 'Ne tenir qu\'à un fil',
    'The nugget': 'La pépite',
    'Has done a lot of prospecting': 'A fait beaucoup de prospection',
    'For those who come after': 'Pour ceux qui viendront après',
    'Has done a lot of testing': 'A effectué de nombreux tests',
    'The scholar': 'L\'érudit',
    'Has done a lot of documentation': 'A fait beaucoup de documentation',
    'The Pretender': 'Le Caméléon',
    'Has filled his timesheet many times in many types of activity': 'A rempli sa timesheet de nombreuses fois avec des activités variées',
    'There are Pretenders among us. Geniuses with the ability to become anyone they want to be.': 'Il existe des êtres doués d\'une intelligence supra normale, des génies qui possèdent entre autres la faculté d\'assumer n\'importe quelle identité.',
    'Did you tried turning it off and on again?': 'Avez-vous essayé de l\'éteindre et de le rallumer?',
    'Has done a lot of support': 'A fait beaucoup de support',
    'It is by doing whatever that we become whoever': 'C\'est en faisant n\'importe quoi qu\'on devient n\'importe qui',
    'Has done a lot of indescribable things': 'A fait beaucoup de choses indescriptibles',
    'Stack Overflow thief': 'Pillard de Stack Overflow',
    'Has done a lot of development': 'A fait beaucoup de développement',
    '2px to the right': '2px à droite',
    'Has done a lot of design': 'A fait beaucoup de design',
    'Month': 'Mois',
    'January': 'Janvier',
    'February': 'Février',
    'March': 'Mars',
    'April': 'Avril',
    'May': 'Mai',
    'June': 'Juin',
    'July': 'Juillet',
    'August': 'Août',
    'September': 'Septembre',
    'October': 'Octobre',
    'November': 'Novembre',
    'December': 'Décembre',
    'Ideas box': 'Boîte à idées',
    'Comments': 'Commentaires',
    'Comment': 'Commentaire',
    'Comment added': 'Commentaire ajouté',
    'Comment could not be added': 'Le commentaire n\'a pas pu être ajouté',
    'Add': 'Ajouter',
    'Today': 'Aujourd\'hui',
    'For me': 'Pour moi',
    'Refuse the suggestion?': 'Refuser la suggestion?',
    'Accept the suggestion?': 'Accepter la suggestion?',
    'Occupancy rate': 'Taux d\'occupation',
    'Workload': 'Charge de travail',
    'Active projects': 'Projets actifs',
    'Team status': 'Statut de l\'équipe',
    'Estimate the number of days you are busy during the week': 'Estimation du nombre de jours où tu es occupé sur la semaine',
    'updated': 'mis à jour',
    'by': 'par',
    'New suggestions': 'Nouvelles suggestions',
    'Status': 'Statut',
    'Calendar': 'Calendrier',
    'List': 'Liste',
    'This field can be edited. Don\'t forget to deduct half days.': 'Ce champ est éditable. N\'oubliez pas de déduire les demi-jours.',
    'Timesheet not up to date': 'Timesheet pas à jour',
    'Weekly to create': 'Weekly à créer',
    'Total hours': 'Total heures',
    'items': 'éléments',
    'My weeklies only': 'Mes weeklies uniquement',
    'Quests': 'Quêtes',
    'Fill in my timesheet': 'Remplir ma timesheet',
    'Create my weekly': 'Créer mon weekly',
    'Check that my leaves have been filled correctly': 'Vérifier si mes congés ont été remplis correctement',
    'Unvoted': 'Non voté',
    'Vote for %{count} suggestions': 'Voter pour %{count} suggestions',
    'Rules': 'Règlement',
    'Privacy': 'Confidentialité',
    'Leaderboard': 'Classement',
    'My impact': 'Mon impact',
    'Personal': 'Personnel',
    'total hours/max capacity': 'heures totales/capacité max',
    'hours worked/total hours': 'heures prestées/heures totales',
    'Most commonly used types': 'Types les plus utilisés',
    'Most commonly used types in timesheet': 'Types les plus utilisés dans la timesheet',
    'Project count': 'Nombre de projets',
    'Days filled in timesheet': 'Jours remplis dans la timesheet',
    'Only leaves with type "leave" are counted.': 'Seuls les congés de type "congé" sont comptabilisés.',
    'Make two different requests if your leaves overlap two months (this will make the automatic calculations easier).': 'Il faut faire deux demandes distinctes si les congés chevauchent deux mois (afin de faciliter le calcul automatique).',
    'The field "number of days" can be edited. Don\'t forget to deduct half days.': 'Le champ "nombre de jours" est éditable. N\'oubliez pas de déduire les demi-jours',
    'Settings': 'Paramètres',
    'Web process': 'Process web',
    'Project follow-up': 'Suivi de projet',
    'Quick actions': 'Actions rapides',
    'Visible on': 'Visible sur',
    'On all pages': 'Sur toutes les pages',
    'Disabled': 'Désactivé',
    'Figma process': 'Process Figma',
    'No data for this month': 'Pas de données pour ce mois',
    'Days': 'Jours',
    'Settings updated': 'Paramètres mis à jour',
    'API tokens': 'Tokens API',
    'Personal tokens let your scripts use the API on your behalf.': 'Les tokens personnels permettent à vos scripts d\'utiliser l\'API en votre nom.',
    'New token': 'Nouveau token',
    'New API token': 'Nouveau token API',
    'Your new API token': 'Votre nouveau token API',
    'What is this token for? E.g. "Timesheet script"': 'À quoi sert ce token ? Ex. "Script timesheet"',
    'Permissions': 'Permissions',
    'Full access': 'Accès complet',
    'Read my timesheet': 'Lire ma timesheet',
    'Write my timesheet': 'Écrire dans ma timesheet',
    'Read projects and types': 'Lire les projets et les types',
    'This token gives access to the whole API. Keep it secret.': 'Ce token donne accès à toute l\'API. Gardez-le secret.',
    'Expiration': 'Expiration',
    '30 days': '30 jours',
    '90 days': '90 jours',
    '1 year': '1 an',
    'Copy it now: you will not be able to see it again.': 'Copiez-le maintenant : vous ne pourrez plus le revoir.',
    'Send it in the Authorization header:': 'Envoyez-le dans le header Authorization :',
    'Token copied': 'Token copié',
    'Unable to copy the token': 'Impossible de copier le token',
    'Unable to create the token': 'Impossible de créer le token',
    'Unable to revoke the token': 'Impossible de révoquer le token',
    'Revoke the token "%{name}"? Scripts using it will stop working.': 'Révoquer le token "%{name}" ? Les scripts qui l\'utilisent ne fonctionneront plus.',
    'Token revoked': 'Token révoqué',
    'Revoke': 'Révoquer',
    'Revoked': 'Révoqué',
    'Expired': 'Expiré',
    'Last used': 'Dernière utilisation',
    'No API token yet': 'Aucun token API pour l\'instant',
    'More information here': 'Plus d\'informations ici',
    'Billing companies': 'Sociétés de facturation',
    'Billing addresses': 'Adresses de facturation',
    'Archived': 'Archivé',
    'Timesheet calendar': 'Calendrier timesheet',
    'Addresses': 'Adresses',
    'Utilization %': 'Utilisation %',
    'Copy last weekly': 'Copier dernier weekly',
    'This week': 'Cette semaine',
    'What are you working on?': 'Sur quoi travailles-tu ?',
    'Maximum level reached': 'Niveau maximal atteint',
    review_kind: {
        manager: 'Évaluation manager',
        self: 'Auto-évaluation',
        pair: 'Retour de pair'
    },
    review_status: {
        draft: 'Brouillon',
        submitted: 'Soumise',
        shared: 'Partagée',
        final: 'Finalisée'
    },
    'Review grid': "Grille d'évaluation",
    'How to score': 'Comment noter',
    'Target by stage': 'Cible par étage',
    'not expected': 'non attendu',
    'Axis': 'Axe',
    'Score': 'Note',
    'Target': 'Cible',
    'Gap': 'Écart',
    'Not observed': 'Non observé',
    'Not applicable': 'Non applicable',
    'The fact behind the score': 'Le fait qui fonde la note',
    'Period': 'Période',
    'For example S2 2026': 'Par exemple S2 2026',
    'From': 'Du',
    'To': 'Au',
    'Current stage': 'Étage actuel',
    'Target stage': 'Étage visé',
    'Values embodied': 'Valeurs incarnées',
    'Passion, Team, Quality and integrity, Extra mile, Innovation: which show, which is missing?': 'Passion, Team, Qualité et intégrité, Extra mile, Innovation : lesquelles se voient, laquelle manque ?',
    'Strengths': 'Points forts',
    'Areas to improve': 'Points à améliorer',
    'Objectives (verifiable)': 'Objectifs (vérifiables)',
    'Objective': 'Objectif',
    'Person': 'Personne',
    'Type': 'Type',
    'Updated': 'Mis à jour',
    'Reviewer': 'Évaluateur',
    'Submit': 'Soumettre',
    'Share with the person': 'Partager avec la personne',
    'Finalize': 'Finaliser',
    'Once submitted, your self review can no longer be changed.': 'Une fois soumise, ton auto-évaluation ne peut plus être modifiée.',
    'The person will be able to read this review.': 'La personne pourra lire cette évaluation.',
    'A finalized review is locked for good.': 'Une évaluation finalisée est verrouillée définitivement.',
    'Not observed: leave empty': 'Non observé : laisser vide',
    'Not applicable to this person': 'Sans objet pour cette personne',
    'N/A': 'Sans objet',
    'What happened, when: a dated fact': 'Ce qui s\'est passé, quand : un fait daté',
    'Sets the target of each axis': 'Fixe la cible de chaque axe',
    'Review summary': 'Synthèse',
    'Objectives': 'Objectifs',
    'The four levels': 'Les quatre niveaux',
    'Review list': 'Liste des évaluations',
    'Stage': 'Étage',
    'Dashed: target stage': 'En pointillé : étage visé',
    'Profile': 'Profil',
    'Read the shape, not an average: each spoke is one axis, from Learn at the centre to Inspire at the edge.': "On lit la forme, pas une moyenne : chaque rayon est un axe, de Learn au centre à Inspire au bord.",
    'Stage target': "Cible de l'étage",
    'At a glance': "En un coup d'œil",
    'Above target': 'Au-dessus de la cible',
    'On target': 'À la cible',
    'Below target': 'Sous la cible',
    'Not scored': 'Non notés',
    'No current stage: no target to compare with.': "Pas d'étage actuel : aucune cible pour comparer.",
    'Spread across levels': 'Répartition par niveau',
    'Above the stage target': "Au-dessus de la cible de l'étage",
    'Below the stage target': "Sous la cible de l'étage",
    'No review has been shared with you yet.': "Aucune évaluation ne t'a encore été partagée.",
    'Reviews are written by your manager. You will find here the ones shared with you.': 'Les évaluations sont rédigées par ton manager. Tu retrouves ici celles qui te sont partagées.',
    'Two objectives that can be answered yes or no at the next review.': 'Deux objectifs auxquels on pourra répondre oui ou non à la prochaine évaluation.',
    'Review not found': 'Évaluation introuvable',
    'Only the review manager can create a review': 'Seul le manager crée les évaluations',
    'Only the review manager can write a manager review': 'Seul le manager rédige une évaluation manager',
    'Peer reviews are not available yet': 'Les retours de pairs ne sont pas encore ouverts',
    'Self reviews are not open yet': 'Les auto-évaluations ne sont pas encore ouvertes',
    'Unknown person': 'Personne inconnue',
    'This review can no longer be edited': 'Cette évaluation ne peut plus être modifiée',
    'This review cannot be submitted': 'Cette évaluation ne peut pas être soumise',
    'This review cannot be shared': 'Cette évaluation ne peut pas être partagée',
    'This review cannot be finalized': 'Cette évaluation ne peut pas être finalisée',
    'Only a draft can be deleted': 'Seul un brouillon peut être supprimé',
    'The period ends before it starts': 'La période se termine avant de commencer',
    "Only its owner can change the review manager's account": 'Seul son titulaire peut modifier le compte du manager des évaluations',
    'This email is reserved': 'Cette adresse est réservée',
    'Action plan': "Plan d'action",
    'What the person will put in place to reach the objectives or improve the situation.': "Ce que la personne met en place pour atteindre les objectifs ou améliorer la situation.",
    'Edit my action plan': "Modifier mon plan d'action",
    'Write my action plan': "Écrire mon plan d'action",
    'Concrete actions, with a date when possible.': 'Des actions concrètes, datées si possible.',
    'Not written yet.': 'Pas encore rédigé.',
    'Updated on %{date}': 'Mis à jour le %{date}',
    'Only the person reviewed can write the action plan, while the review is shared': "Seule la personne évaluée écrit son plan d'action, tant que l'évaluation est partagée",
    'The action plan is too long': "Le plan d'action est trop long",
    focus_load: {
        low: 'Faible',
        normal: 'Normale',
        high: 'Élevée',
        overloaded: 'Surchargé'
    },
    focus_priority: {
        high: 'Haute',
        medium: 'Moyenne',
        low: 'Basse'
    },
    focus_status: {
        active: 'Active',
        paused: 'En pause',
        done: 'Terminée'
    },
    'Who is on what, high level. Loads are measured from the timesheet, not declared.': 'Qui est sur quoi, en high level. Les charges sont mesurées dans la timesheet, pas déclarées.',
    'Expand all': 'Tout déplier',
    'Collapse all': 'Tout replier',
    'Recompute': 'Recalculer',
    'Computing…': 'Calcul…',
    'No headline yet': 'Pas encore de ligne high level',
    'Measured load': 'Charge mesurée',
    'Planned load': 'Charge prévue',
    'Hours logged over hours due on the last 4 weeks (leaves and holidays deducted)': 'Heures loguées sur heures dues, 4 dernières semaines (congés et fériés déduits)',
    'Days per week of the active priorities over the capacity': 'Jours par semaine des priorités actives sur la capacité',
    'My perception of the load': 'Ma perception de la charge',
    'Perceived': 'Perçue',
    'Timesheet': 'Timesheet',
    'Projects carried (8 h or more) / touched, and client projects': 'Projets portés (8 h et plus) / touchés, et projets clients',
    'projects': 'projets',
    'clients': 'clients',
    'No priority yet': 'Aucune priorité pour le moment',
    'more': 'de plus',
    'Planned': 'Prévu',
    'd/wk': 'j/sem',
    'Add a priority': 'Ajouter une priorité',
    'Total': 'Total',
    'spent': 'consommé',
    'Delete this priority?': 'Supprimer cette priorité ?',
    'Where the time went (4 weeks)': 'Où est passé le temps (4 semaines)',
    'internal': 'interne',
    'due': 'dues',
    'computed on': 'calculé le',
    'not computed yet': 'pas encore calculé',
    'Headline': 'Ligne high level',
    'For example: Odoo + web': 'Par exemple : Odoo + web',
    'Capacity (days / week)': 'Capacité (jours / semaine)',
    'Note': 'Note',
    'Edit the priority': 'Modifier la priorité',
    'New priority': 'Nouvelle priorité',
    'Title': 'Titre',
    'Description': 'Description',
    'Priority': 'Priorité',
    'Total effort (days)': 'Effort total (jours)',
    'Effort per week (days)': 'Effort par semaine (jours)',
    'Linked projects': 'Projets liés',
    'The time logged on these projects counts as effort spent.': 'Le temps logué sur ces projets compte comme effort consommé.',
    'Only the manager can change the focus board': 'Seul le manager modifie le tableau Focus',
    'Overcommitted: %{pct} % of the capacity planned': 'Surengagé : %{pct} % de la capacité prévus',
    '"%{title}": no time logged on its projects in 4 weeks': '« %{title} » : aucune heure sur ses projets en 4 semaines',
    'You see a heavy load, the timesheet measures %{pct} %': 'Tu perçois une charge forte, la timesheet mesure %{pct} %',
    'You see a light load, the timesheet measures %{pct} %': 'Tu perçois une charge faible, la timesheet mesure %{pct} %',
    'Timesheet quality %{score}/100: read the figures with care': 'Timesheet à %{score}/100 : chiffres à lire avec prudence',
    'Measured load, 90 days': 'Charge mesurée, 90 jours',
    'The curve appears after a few daily computations.': 'La courbe apparaît après quelques calculs quotidiens.',
    'Paused and done (%{count})': 'En pause et terminées (%{count})',
    'Planned on the team capacity': "Prévu sur la capacité de l'équipe",
    'Above 110 % measured': 'Au-dessus de 110 % mesurés',
    'Under 70 % measured': 'Sous 70 % mesurés',
    'Active priorities': 'Priorités actives',
    'Without priority': 'Sans priorité',
    'Alerts to look at': 'Alertes à regarder',
    'Who is on… (priority, project, headline)': 'Qui est sur… (priorité, projet, ligne high level)',
    'Sort by': 'Trier par',
    'Only people without priority': 'Seulement les personnes sans priorité',
    'Nobody matches these filters.': 'Personne ne correspond à ces filtres.',
    'Where this person spent time lately:': 'Là où cette personne a passé du temps récemment :',
    '4 weeks': '4 semaines',
    'Timesheet quality': 'Qualité de la timesheet',
    'carried (8 h or more over 4 weeks)': 'portés (8 h et plus sur 4 semaines)',
    'touched': 'touchés',
    'client': 'client',
    'Hours per week': 'Heures par semaine',
    'Due': 'Dues',
    'Logged': 'Loguées',
    'Trend, 90 days': 'Tendance, 90 jours',
    'Back to the board': 'Retour au tableau',
    'Completion': 'Complétion',
    'Days with at least one line, over the days due (leaves and holidays deducted)': 'Jours avec au moins une ligne, sur les jours dus (congés et fériés déduits)',
    'Timesheet quality: precise, on time, complete, typed, sized, not rounded': 'Qualité de la timesheet : précise, à temps, complète, typée, bien découpée, pas arrondie',
    'Precise descriptions': 'Descriptions précises',
    'Logged the same or next day': 'Saisies le jour même ou le lendemain',
    'Days filled': 'Jours remplis',
    'Typed (not other)': 'Typées (pas « other »)',
    'Lines under 5 h': 'Lignes de moins de 5 h',
    'Hours not rounded': 'Heures non arrondies',
    'days filled': 'jours remplis',
    'missing': 'manquants',
    'Last line logged': 'Dernière ligne saisie',
    'Timesheet %{pct} % complete: %{missing} days missing, last line on %{last}': 'Timesheet complète à %{pct} % : %{missing} jours manquants, dernière ligne le %{last}',
    'Timesheets to complete': 'Timesheets à compléter',
    '(no description)': '(sans description)',
    'Holiday': 'Férié',
    'nothing': 'rien',
    'Half-day leave': 'Demi-jour de congé',
    'vague': 'vague',
    'logged %{days} d later': 'saisie %{days} j plus tard',
    'days due without any line': 'jours dus sans aucune ligne',
    'weeks': 'semaines'
};

export default translations;
